import { HOME_URL } from "./homeUrl";

export const FONTS_LINK = [
  {
    rel: "prefetch",
    href: `${HOME_URL}/assets/fonts/Inter-Regular.woff2`,
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  },
  {
    rel: "prefetch",
    href: `${HOME_URL}/assets/fonts/SFPro-Medium.woff2`,
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  },
  {
    rel: "prefetch",
    href: `${HOME_URL}/assets/fonts/SFPro-Regular.woff2`,
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  },
];
